module.exports = __webpack_public_path__ + "img/DW365-236.832a7851.jpg";